import styled from 'styled-components'
import { Layout } from 'antd'
import theme from '../../styles/theme'
import { Content } from 'antd/es/layout/layout'

export const LayoutWrapper = styled.div`
  .ant-layout {
    display: flex;
  }

  .ant-layout-has-sider {
    flex-direction: row;
  }
`

export const StyledLayout = styled(Layout)`
  background-color: ${theme.colors.white};
  flex: 1;
  display: flex;
  flex-direction: column;
`

export const StyledContent = styled(Content)`
  padding: 0;
  margin: 0;
  min-height: 280px;
  flex: 1;
  display: flex;
  flex-direction: column;
`

export const ContentWrapper = styled.div`
  padding: 10px 20px;
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: ${theme.colors.white};

  @media (max-width: 768px) {
    padding: 0 10px;
  }
`

export const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const Copyright = styled.div`
  color: ${({ theme }) => theme.colors.grayDark};
  padding: 20px;
`

export const TableFooterContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 16px;
  padding: 8px;

  .ant-select-dropdown {
    top: auto !important;
    bottom: 100% !important;
    transform: unset !important;
  }

  @media (max-width: 768px) {
    .ant-pagination {
      .ant-pagination-item,
      .ant-pagination-prev,
      .ant-pagination-next {
        min-width: 44px;
        height: 44px;
        line-height: 42px;
        font-size: 16px;
        border-radius: 8px;
      }
      .ant-pagination-item a {
        line-height: 42px;
      }
      .ant-pagination-prev .ant-pagination-item-link,
      .ant-pagination-next .ant-pagination-item-link {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        font-size: 18px;
      }
      .ant-pagination-options {
        .ant-select-selector {
          height: 44px;
          padding: 0 12px;
          font-size: 16px;
          .ant-select-selection-item {
            line-height: 42px;
          }
        }
      }
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    justify-content: center;
    gap: 8px;
    padding: 0;
  }
`

export const TableFooterActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const TableFooterInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
  font-size: 14px;
`
export const MenuWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  align-items: stretch;
`

interface MenuHeaderProps {
  isCollapsed?: boolean
}

export const MenuHeader = styled.div.withConfig({
  shouldForwardProp: prop => prop !== 'isCollapsed',
})<MenuHeaderProps>`
  padding: 20px;
  display: flex;
  justify-content: end;

  ${({ isCollapsed }) =>
    isCollapsed &&
    `
      .logo-mini-icon {
        width: 0;
        padding: 0;
      }
      .sidebar-icon {
        flex: 1;
        text-align: center
      }
    `}
`

export const UserProfileMenuWrapper = styled.div`
  li {
    text-overflow: unset !important;
  }
`

export const OrganizationLogoWrapper = styled.span`
  display: flex;
  color: #fff;
  padding: 0;
  margin: 0;
  flex-direction: row;
  justify-content: center;
  background-color: #ffffff;
`
